import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { VatPatternDto } from '../models/vatPattern/vatpatterndto';
import { VatConfigPatternDto } from '../models/vatPattern/vatConfigPatternDto.model';
import { AppConfigService } from './core/appConfig.service';
@Injectable({
    providedIn: 'root'
})
export class VatPatternService {

    constructor(private http: HttpClient, private configService: AppConfigService) { }

    getListVatPattern(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/vat-pattern/listAll?${params}`).pipe(map(response => { return response; }));
    }

    getListConfigPattern(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', 100)
            .set('orderField', 'idVatConfigPattern')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/vat-pattern/config/listAll?${params}`).pipe(map(response => { return response; }));
    }

    getVatPatternById(idVatPattern: number | null): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-pattern/filter/${idVatPattern}`;
        return this.http.get<any>(url).pipe(
            map(response => {
                return new VatPatternDto(response);
            })
        );
    }

    getConfigPatternById(idVatConfigPattern: number): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/config/filter/${idVatConfigPattern}`;
        return this.http.get<any>(url).pipe(
            map(response => {
                return new VatConfigPatternDto(response);
            })
        );
    }

    insertVatPattern(vatPattern: VatPatternDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-pattern/insert`;
        return this.http.post<any>(url, vatPattern).pipe(
            map(response => {
                return new VatPatternDto(response);
            })
        );
    }

    insertConfigPattern(vatConfig: VatConfigPatternDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-pattern/config/insert`;
        return this.http.post<any>(url, vatConfig).pipe(
            map(response => {
                return new VatConfigPatternDto(response);
            })
        );
    }

    updateVatPattern(vatPattern: VatPatternDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-pattern/update/true`;
        return this.http.put<any>(url, vatPattern).pipe(
            map(response => {
                return new VatPatternDto(response);
            })
        );
    }

    updateConfigPattern(vatConfig: VatConfigPatternDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-pattern/config/update`;
        return this.http.put<any>(url, vatConfig).pipe(
            map(response => {
                return new VatConfigPatternDto(response);
            })
        );
    }

    getProvinces(token: string): Observable<any> {
        const params = new HttpParams()
            .set('pageNumber', 0)
            .set('pageSize', 200);
        const headers = new HttpHeaders({
            'Authorization-tercer': `Bearer ${token}`
        });
        const url = `${this.configService.apiUrl}/tercer/getAll/provinces?${params}`;
        return this.http.get<any>(url, { headers }).pipe(
            map(response => {
                return response;
            })
        );
    }

    getCountries(token: string, ue: boolean): Observable<any> {
        const params = new HttpParams()
            .set('isEuropeanUnion', ue)
            .set('pageNumber', 0)
            .set('pageSize', 300);
        const headers = new HttpHeaders({
            'Authorization-tercer': `Bearer ${token}`
        });
        const url = `${this.configService.apiUrl}/tercer/getAll/countries?${params}`;
        return this.http.get<any>(url, { headers }).pipe(
            map(response => {
                return response;
            })
        );
    }

    getCommunities(token: string): Observable<any> {
        const params = new HttpParams()
            .set('pageNumber', 0)
            .set('pageSize', 100);
        const headers = new HttpHeaders({
            'Authorization-tercer': `Bearer ${token}`
            
        });
        const url = `${this.configService.apiUrl}/tercer/getAll/communities?${params}`;
        return this.http.get<any>(url, { headers }).pipe(
            map(response => {
                return response;
            })
        );
    }

    getToken(): Observable<any> {
        const url = `${this.configService.apiUrl}/tercer/generateToken`;
        return this.http.get<any>(url).pipe(
            map(response => {
                return response;
            })
        );
    }
}